@use '../../style/globals.scss' as *;

$foreground-primary: white;
$foreground-secondary: #797979;
$background-primary: #111111;
$background-secondary: #1b1b1b;
$background-highlight: #313131;

.MyRewardsDrawer {
    position: absolute;
    top: 0;
    right: -($sidebar-width);
    width: 100%;
    height: 100%;
    background-color: $background-primary;
    color: $foreground-primary;
    transition: $sidebar-transition, opacity 0s linear 0.5s;
    opacity: 0;
    z-index: 10;

    @media (max-width: $bp-mobile-chat) {
        right: -100%;
        width: 100%;
    }

    &.isOpen {
        right: 0;
        transition: $sidebar-transition, opacity 0s linear 0s;
        opacity: 1;
    }

    .scrollContainer {
        @include scrollbar-styles;
        position: relative;
        overflow-y: auto;
        width: 100%;
        height: 100%;
    }

    h2 {
        font-family: var(--font-primary);
        font-size: $font-size-h6;
        text-align: center;
    }

    .topBar {
        position: absolute;
        width: 100%;
        height: 80px;

        .title {
            position: absolute;
            top: 25px;
            left: 50%;
            text-align: center;
            transform: translateX(-50%);
        }

        .closeButton {
            position: absolute;
            top: 10px;
            right: 10px;
        }
    }

    .content {
        @include border-image();
        position: absolute;
        top: 70px;
        left: 50%;
        width: 404px;
        max-width: calc(100% - 40px);
        min-height: 500px;
        padding: 20px;
        transform: translateX(-50%);
        background-color: $background-secondary;
        border-radius: 10px;

        .title {
            margin: 10px;
        }

        .emptyText {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%);
            text-align: center;
        }

        ul {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            width: 100%;
        }

        li {
            display: block;
            width: calc(50% - 10px);
        }
    }
}
